import { useState } from "react";
import AddressMap from "./AddressMap";
import axios from "axios";

const SearchMap = ({ customerId, searchedPlace, handleClose, setLoading }) => {

    const api = '/api/';
    const [nearbyCompanies, setNearbyCompanies] = useState([]);
    const [boundaryInfo, setBoundaryInfo] = useState(null);
    const [selectedPlace, setSelectedPlace] = useState(searchedPlace ?? null)

    const fetchSearchResults = async (data) => {
        try {
            setLoading(true);
            const response = await axios.post(`${api}address/search/${customerId}`, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response?.data;
        } catch (error) {
            console.error("fetchSearchAddressResults error", error)
        } finally {
            setLoading(false)
        }
    }

    const handlePlaceSelect = async (place) => {
        setNearbyCompanies([]);
        const data = {
            "attributeSearchItems": [
                {
                    "attributeName": "Address",
                    "searchString": place.formatted_address,
                    "isGlobal": false,
                    "zipRadium": null,
                    "addressRadius": null
                }
            ],
            "sortInfo": {},
            "templateId": null
        }


        const response = await fetchSearchResults(data);
        setSelectedPlace(place)
        setNearbyCompanies(response?.results);
        setBoundaryInfo(response?.boundary ?? null);
    };

    return (
        <>
            <AddressMap
                searchedPlace={selectedPlace}
                companies={nearbyCompanies ?? []}
                handlePlaceSelect={handlePlaceSelect}
                boundaryInfo={boundaryInfo}
                setLoading={setLoading}
                handleClose={handleClose}
            />
        </>
    )
}

export default SearchMap;